import imageIcons from '@assets/css/image-icons.css';

/**
 * Image icons styles.
 * @type {CSSStyleSheet}
 */
export const imageIconsStyles = new CSSStyleSheet();
imageIconsStyles.replaceSync(imageIcons);
